import {
  Typography as MuiTypography,
  withStyles,
  styled,
  ListItem as MuiListItem,
  Switch as MuiSwitch,
  Popper as MuiPopper,
} from '@material-ui/core';
import { Link as RouterDOMLink } from 'react-router-dom';

import { drawerWidth } from 'layouts/Dashboard/constants';
import { COLORS } from 'theme/constants';

export const ImageUploadCaption = withStyles({
  root: {
    display: 'block',
    backgroundColor: COLORS.bgLight,
    padding: '6px 12px',
    borderRadius: '2px',
    fontSize: '12px',
  },
})(MuiTypography);

export const Image = styled('img')({
  display: 'block',
  maxHeight: '100%',
  maxWidth: '100%',
  objectPosition: 'center',
  objectFit: 'contain',
  borderRadius: 'inherit',
  '&.obj-fit-sd': { 'object-fit': 'scale-down' },
});

export const RouterLink = styled(RouterDOMLink)({
  textDecoration: 'none',
});

export const ListItem = withStyles({
  root: {
    padding: '0 0 8px',
    '& .MuiButton-label': { justifyContent: 'flex-start' },
  },
})(MuiListItem);

export const WrapperDisplayTable = withStyles({
  root: {
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
  },
})('div');

export const WrapperScroll = styled('div')(({ theme }) => ({
  maxWidth: 'calc(100vw - 40px)',
  overflowX: 'auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: `calc(100vw - ${drawerWidth}px - 40px)`,
    overflowX: 'auto',
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: `calc(100vw - ${drawerWidth}px - 80px)`,
    overflowX: 'auto',
  },
}));

export const Switch = withStyles(theme => ({
  root: {
    '& .MuiSwitch-thumb': {
      boxShadow: `0 2px 4px 0 ${COLORS.cozmosPurpleLight}`,
    },
    '&  .MuiSwitch-track': {
      background: COLORS.cozmosPurple2,
      opacity: 1,
    },
    '& .Mui-checked + .MuiSwitch-track': {
      background: COLORS.cozmosPurple5,
      opacity: 1,
    },
  }
}))(MuiSwitch);

export const Popper = styled(MuiPopper)({
  marginTop: '-9px',
  marginLeft: '22px',
  '& ul': {
    padding: 0,
  },
  '& ul li:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  }
});
